<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import AssignModal from "./assign_modal.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin';
import Datatable from '@/components/Datatable';
import { notify } from '@/helpers/notify';

export default {
  page: {
    title: "Verici Arıza Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [datatableMixin],
  components: {
    Layout,
    PageHeader,
    AssignModal,
    Datatable,
  },
  data() {
    return {
      title: "VERİCİ ARIZA LİSTESİ",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "VERİCİ ARIZA LİSTESİ", active: true },
      ],
      disableAutoLoad: true,
      endpoint: '/transmitter/faults',
      allRows: [],
      buttons: [
        { title: "Randevu Ver", icon: "bx bx-calendar-event", func: this.assign },
        { title: "Tablodan Kaldır", icon: "bx bx-trash", func: this.sil },
      ],
      list: {},
      columns: [
        { name: '', key: 'action', orderable: false },
        { name: 'Tip', key: 'type', orderable: false, width: 100 },
        { name: 'POP', key: 'transmitter_group_name', orderable: true },
        { name: 'Verici Adı', key: 'transmitter_name', orderable: true },
        { name: 'Bölge', key: 'district_name', orderable: true },
        { name: 'Personel', key: 'assigned_username', orderable: false, width: 140 },
        { name: 'Randevu Tarihi', key: 'appointment_at', orderable: false, width: 180 },
      ],
      tableData: {
        detail: false,
        excel: false,
        searchable: {
          visible: true,
          placeholder: "POP, Verici, Bölge veya Personel Ara",
        },
      },
      modelOpen: 0,
      assignData: {},
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      this.isLoading = true;

      try {
        const response = await this.$http.post(this.endpoint, {
          sort: this.sort.column
            ? [{ field: this.sort.column, type: this.sort.order || 'asc' }]
            : [{ field: '', type: '' }],
        });

        const rows = Array.isArray(response.data)
          ? response.data
          : (response.data.data || []);

        this.allRows = rows;
        this.applyLocalFilter();
      } finally {
        this.isLoading = false;
        this.pageLoading = false;
      }
    },

    applyLocalFilter() {
      const query = (this.searchQuery || '').toString().trim().toLowerCase();
      let rows = [...this.allRows];

      if (query) {
        rows = rows.filter(row => {
          const haystack = [
            row.transmitter_group_name,
            row.transmitter_name,
            row.district_name,
            row.assigned_username,
          ].join(' ').toLowerCase();
          return haystack.indexOf(query) !== -1;
        });
      }

      if (this.sort.column && this.sort.order) {
        const column = this.sort.column;
        const order = this.sort.order === 'desc' ? -1 : 1;
        rows.sort((a, b) => {
          const left = a[column] == null ? '' : a[column];
          const right = b[column] == null ? '' : b[column];
          if (left < right) return -1 * order;
          if (left > right) return 1 * order;
          return 0;
        });
      }

      this.tableData.data = rows;
      this.tableData.pagination = {
        current_page: 1,
        last_page: 1,
        total: rows.length,
      };
    },

    reLoadPage(query) {
      this.searchQuery = query;
      this.applyLocalFilter();
    },

    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;
      this.sort.column = columnKey;
      this.sort.order = sortOrder;
      this.applyLocalFilter();
    },

    assign(props) {
      this.modelOpen += 1;
      this.assignData = { type: 3, subs_id: props.subs_id, tech_id: props.id };
      this.$parent.$bvModal.show('assign_modal');
    },

    sil(props) {
      this.$swal({
        title: "Silinecek?",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((result) => {
        if (result.value) {
          this.$http.delete('/technic-service/ariza-sil/' + props.id)
            .then(response => {
              if (response.data.code != 100) {
                return notify.error(response.data.message);
              }
              this.loadPage();
              return notify.success(response.data.message);
            });
        }
      });
    },

    typeBadge(row) {
      if (row.type == 3) {
        return { class: 'bg-warning', text: 'Arıza' };
      }
      return { class: 'bg-danger', text: 'Söküm' };
    },

    appointmentText(row) {
      if (!row.appointment_at) return '-';
      if (row.postpone) {
        const desc = row.histories && row.histories[0] ? row.histories[0].description : '';
        return desc || 'Ertelenmiş';
      }
      return this.formatDate(row.appointment_at, 'DD.MM.YYYY HH') + ':00';
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <AssignModal
      :modelOpen="modelOpen"
      :assignData="assignData"
      @loadItems="loadPage"
    />

    <div class="row">
      <div class="col-12">
        <Datatable
          :columns="columns"
          :tableData="tableData"
          @search-query="reLoadPage"
          @sort-column="handleSortColumn"
          :loading="isLoading"
          :poading="pageLoading"
        >
          <template #type="{ row }">
            <span class="badge font-size-12" :class="typeBadge(row).class">
              {{ typeBadge(row).text }}
            </span>
          </template>

          <template #appointment_at="{ row }">
            <span
              v-if="row.postpone"
              class="badge rounded-pill bg-warning font-size-12 me-1"
            >Ertelenmiş</span>
            {{ appointmentText(row) }}
          </template>

          <template #action="{ row }">
            <b-dropdown
              toggle-class="font-size-16 p-0"
              toggle-tag="a"
              variant="white"
              append-to-body
            >
              <template #button-content>
                <i class="mdi mdi-dots-horizontal"></i>
              </template>
              <b-dropdown-item
                v-for="(button, i) in buttons"
                :key="i"
                @click="button.func(row)"
              >
                <i :class="button.icon"></i> {{ button.title }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
